var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiveStars = function SvgFiveStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 37,
    fill: "none",
    className: "fiveStars_svg__mx-auto"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#988642",
    d: "m18.5 0 5.459 10.987 12.135 1.796-8.762 8.587 2.042 12.097-10.874-5.68-10.874 5.68L9.668 21.37.905 12.783l12.136-1.796zM59.5 0l5.459 10.987 12.135 1.796-8.761 8.587 2.041 12.097-10.874-5.68-10.874 5.68 2.042-12.097-8.763-8.587 12.136-1.796zM100.5 0l5.459 10.987 12.135 1.796-8.761 8.587 2.041 12.097-10.874-5.68-10.874 5.68 2.042-12.097-8.763-8.587 12.136-1.796zM141.5 0l5.459 10.987 12.136 1.796-8.762 8.587 2.041 12.097-10.874-5.68-10.874 5.68 2.042-12.097-8.763-8.587 12.136-1.796zM182.5 0l5.459 10.987 12.136 1.796-8.762 8.587 2.041 12.097-10.874-5.68-10.874 5.68 2.042-12.097-8.763-8.587 12.136-1.796z"
  })));
};
export default SvgFiveStars;